module.exports = __webpack_public_path__ + "static/img/2.73b7f18.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/10/sp/2.png
// module id = J1Hk
// module chunks = 0